import React, { useEffect } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useNeuroMessages } from '@ignitesales/neuro-application/src/neuro-guide/components/MessageContext';
import { notifySuccess } from '@ignitesales/neuro-application/src/neuro-guide/components/ToastNotifications';
import ShareViaEmailForm from '@ignitesales/neuro-application/src/neuro-guide/components/ShareViaEmailForm';
import {
  triggerIgniteAction,
  useDispatch
} from '@ignitesales/neuro-application/src/neuro-guide/state';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui/index';

const ShareViaEmailModal = ({ className, closeBtn, isOpen, onClose, onEmailComplete }) => {
  const messageContext = useNeuroMessages();
  const dispatch = useDispatch();
  const classes = classnames(className, 'socialModal', 'shareViaEmailModal');

  const onEmailSent = () => {
    notifySuccess('shareViaEmail.sent');
    onClose();
    onEmailComplete();
  };

  useEffect(() => {
    isOpen && dispatch(triggerIgniteAction({ actionName: 'shareViaEmailClicked', value: 'started' }));
  }, [isOpen]);

  return (
    <Modal
      show={isOpen}
      className={classes}
      title={messageContext.getMessage('shareViaEmail.modal.title')}
      onClose={onClose}
      closeBtn={closeBtn}
      nodeId="root"
    >
      <ShareViaEmailForm onSubmit={onEmailSent} />
    </Modal>
  );
};
ShareViaEmailModal.propTypes = {
  className: PropTypes.string,
  closeBtn: PropTypes.any,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ShareViaEmailModal;
